
import { Component, Vue, Prop } from 'vue-property-decorator'
import BaseClass from '../../virtual-class/baseClass'
import { UserModule } from '../../store/modules/user'
@Component
export default class SelectPermission extends Vue {
@Prop({ type: Number }) value!: number
  private get _value() {
    return this.value
  }
  private set _value(val) {
    this.$emit('input', val)
  }
  private options() {
    return UserModule.powerList.map(_ => ({
      value: _.id,
      label: _.name,
    })).reverse()
  }
  private get option() {
    // console.log(this.options())
    var arr = this.options()
    for (var i = 0; i < arr.length; i++) {
      if (arr[i].label === '超级管理员') {
        arr.splice(i, 1)
      }
    }
    // console.log(arr)
    return arr
  }
}
